import styled from '@emotion/styled';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

export const OptionPanel = styled.div`
  display: grid;
  grid-row-gap: 0px;
  grid-column-gap: 16px;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(${({ size }) => size ?? 3}, 1fr);

  > div {
    &:hover {
      .rounded-circle {
        border-color: ${colors['@primary-color']};
        & + span {
          color: ${colors['@primary-color']} !important;
        }
      }
    }
  }
`;

export const circle = css`
  height: 40px;
  width: 40px;
  cursor: pointer;
  border: solid 1px transparent;

  &.disabled {
    cursor: not-allowed;
  }

  > i {
    font-size: 24px;
  }
`;

export const infoStyle = css`
  bottom: 10px;
  right: 10px;
`;

export const draggerStyle = css`
& > .ant-upload.ant-upload-drag {
    border-radius: 10px;
    background: linear-gradient(180deg, #FAFCFF 0%, ${colors['@video-bg']} 100%);
    border-color: ${colors['@border-color-grey']};

  }
`;
